import * as React from 'react'
import styled, { keyframes, css } from 'styled-components'
import { withHsTheme, getThemeValue } from 'fe-lib-theme'

const growBounce = keyframes`
  30% {
    transform: scale(1);
    opacity: .60;
  }
  50% {
    transform: scale(.8);
  }
  70% {
    transform: scale(1.2);
    opacity: 1;
  }
  90% {
    transform: scale(1);
    opacity: .60;
  }
`

const animation = css`1s ${growBounce} infinite`

const LoaderWrapper = withHsTheme(styled.div`
  display: inline-block;
  width: ${p => p.size}px;
  height: ${p => Math.ceil(p.size * 0.75)}px;
  line-height: 0;

  position: ${p => (p.hAlign || p.vAlign ? 'absolute' : null)};
  left: ${p => (p.hAlign ? '50%' : null)};
  top: ${p => (p.vAlign ? '50%' : null)};
  transform: ${p => p.hAlign && 'translateX(-50%)'}
    ${p => p.vAlign && 'translateY(-50%)'};

  > div {
    background-color: ${p => p.fill || getThemeValue(t => t.colors.darkGrey)};
    display: inline-block;
    width: ${p => Math.floor(p.size / 4)}px;
    height: 100%;
    vertical-align: middle;
    opacity: 0.6;
    border-radius: ${p => Math.floor(p.size / 12)}px;

    animation: ${animation};

    &:nth-child(2) {
      margin: 0 ${p => Math.ceil(p.size / 4 / 2)}px;
      animation-delay: 100ms;
    }
    &:nth-child(3) {
      animation-delay: 200ms;
    }
  }
`)

const Loading = styled.span`
  font-size: 0px;
  position: absolute;
  left: -9999;
`

const defaultProps = {
  size: 26,
  hAlign: true,
  vAlign: true,
}

export const BouncingBars = props => (
  <LoaderWrapper
    {...defaultProps}
    {...props}
    alt=""
    data-testid="bouncing-bars-loader-wrapper"
  >
    <div alt="" />
    <div alt="" />
    <div alt="" />
    <Loading aria-live="assertive">Loading</Loading>
  </LoaderWrapper>
)
